import React from 'react'
import ImageGridItem from './ImageGridItem'
import MultiFormGridItem from './MultiFormGridItem'

export default class GridItem extends React.Component{
		constructor(props) {
        super(props);
        this.state = {
            alreadyExistingDelegates: [],
        };
    }

    componentDidMount() {
        let delegateInfoForAccommodationEndpoint = `/api/event-accommodation/get-guest-details-for-booked-accommodation/${this.props.bookingIdsForBookedAccommodations[this.props.item.reference_number]}/${this.props.item.reference_number}`
;
        fetch(delegateInfoForAccommodationEndpoint,  { method: 'GET'})
                 .then(response => response.json())
                 .then(data => this.setState({'alreadyExistingDelegates': data}));
    }

    isEven = (n) => {
        return n % 2 == 0;
    };

    render() {
        let numberOfFormsToRender = this.props.item.bedrooms;
        //console.log('already existing delegates: ', this.state.alreadyExistingDelegates);
        if (this.props.item.bedrooms < this.state.alreadyExistingDelegates.length) {
            // we have more delegates than rooms:
            numberOfFormsToRender = this.state.alreadyExistingDelegates.length
        }
        if (this.isEven(this.props.index)) {
            return (
                <ImageGridItem {...this.props}></ImageGridItem>
            )
        } else {
            return (
                <MultiFormGridItem numberOfFormsToRender={numberOfFormsToRender}
                                   alreadyExistingDelegates={this.state.alreadyExistingDelegates} {...this.props}></MultiFormGridItem>
            )
        }
    }

}


// WEBPACK FOOTER //
// ./src/components/GridItem.js